import RefreshButton from '@/components/RefreshButton';
import { DISCLOSER_KEYS, FILTER_KEYS } from '@/constants/keys.constants';
import { useAppDiscloser, useAppFilters } from '@/hooks';
import {
  ChevronDownIcon,
  CirclePlusIcon,
  SearchIcon,
  UploadIcon,
} from '@/icons';
import { Button, Flex, Input, Select } from 'antd';
import { useState } from 'react';
import type { OrganizationSegmentType } from '../Organization';
import BulkOfficesUpload from './Offices/BulkOfficesUpload';

const OfficesFilters = () => {
  const [openUpload, setOpenUpload] = useState(false);
  const { filters, handleSearch, handleFilter } = useAppFilters(
    FILTER_KEYS.ORG_OFFICES,
  );
  const [_config, handleOpen] = useAppDiscloser(DISCLOSER_KEYS.ORG_OFFICES);
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" className="flex-wrap lg:flex-nowrap">
        <Input
          size="large"
          onChange={handleSearch}
          placeholder="Search Office"
          className="w-[250px] shrink-0"
          prefix={<SearchIcon size={20} className="text-white" />}
        />
        <Select
          allowClear
          size="large"
          style={{ flexShrink: 0, width: 130 }}
          placement="bottomRight"
          placeholder="Branch Type"
          // styles={{ popup: { root: { width: 130 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('type', value)}
          options={[
            { value: 'HEAD', label: 'Head Office' },
            { value: 'BRANCH', label: 'Branch Office' },
          ]}
        />

        <Select
          allowClear
          size="large"
          placement="bottomRight"
          placeholder="Status"
          style={{ flexShrink: 0, width: 130 }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'ACTIVE', label: 'Active' },
            { value: 'INACTIVE', label: 'Inactive' },
          ]}
        />
      </Flex>
      <Flex gap={16} align="center" className="flex-wrap lg:flex-nowrap">
        <RefreshButton endpoints={['getAllOffices', 'getFailedOfficesJobs']} />
        <Button
          size="large"
          type="default"
          className="btn-primary"
          onClick={() => setOpenUpload(true)}
        >
          Upload CSV
          <UploadIcon size={20} className="!text-[#444444] !font-bold" />
        </Button>
        <Button
          size="large"
          onClick={() => handleOpen({ type: 'ADD' })}
          className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
        >
          <CirclePlusIcon size={20} />
          Add New Office
        </Button>
      </Flex>
      <BulkOfficesUpload
        open={openUpload}
        handleClose={() => setOpenUpload(false)}
      />
    </div>
  );
};

const DepartmentsFilters = () => {
  const { filters, handleFilter } = useAppFilters(FILTER_KEYS.ORG_DEPARTMENTS);
  const [_config, handleOpen] = useAppDiscloser(DISCLOSER_KEYS.ORG_DEPARTMENTS);
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Select
          allowClear
          size="large"
          placement="bottomRight"
          placeholder="Status"
          style={{ flexShrink: 0, width: 130 }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Add New Department
      </Button>
    </div>
  );
};

const DesignationsFilters = () => {
  const { filters, handleFilter } = useAppFilters(FILTER_KEYS.ORG_DESIGNATIONS);
  const [_config, handleOpen] = useAppDiscloser(
    DISCLOSER_KEYS.ORG_DESIGNATIONS,
  );
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Select
          allowClear
          size="large"
          placement="bottomRight"
          placeholder="Status"
          style={{ flexShrink: 0, width: 130 }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Add New Designations
      </Button>
    </div>
  );
};

const GradesFilters = () => {
  const { filters, handleFilter } = useAppFilters(FILTER_KEYS.ORG_GRADES);
  const [_config, handleOpen] = useAppDiscloser(DISCLOSER_KEYS.ORG_GRADES);
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Office"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('branch', value)}
          options={[
            { value: 'main-office', label: 'Main Office' },
            { value: 'branch-1', label: 'Branch 1' },
            { value: 'branch-2', label: 'Branch 2' },
            { value: 'remote', label: 'Remote' },
          ]}
        />

        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Department"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('branch', value)}
          options={[
            { value: 'main-office', label: 'Main Office' },
            { value: 'branch-1', label: 'Branch 1' },
            { value: 'branch-2', label: 'Branch 2' },
            { value: 'remote', label: 'Remote' },
          ]}
        />

        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Designation"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('branch', value)}
          options={[
            { value: 'main-office', label: 'Main Office' },
            { value: 'branch-1', label: 'Branch 1' },
            { value: 'branch-2', label: 'Branch 2' },
            { value: 'remote', label: 'Remote' },
          ]}
        />

        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Status"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
            { value: 'draft', label: 'Draft' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Add New Grades
      </Button>
    </div>
  );
};

const CustomFieldsFilters = () => {
  const { filters, handleSearch, handleFilter } = useAppFilters(
    FILTER_KEYS.ORG_CUSTOM_FIELDS,
  );
  const [, handleOpen] = useAppDiscloser(DISCLOSER_KEYS.ORG_CUSTOM_FIELDS);

  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Input
          size="large"
          onChange={handleSearch}
          placeholder="Search field"
          className="shrink-0 w-[225px]"
          prefix={<SearchIcon size={24} />}
        />

        <Select
          allowClear
          size="large"
          placement="bottomRight"
          placeholder="Status"
          style={{ flexShrink: 0, width: 130 }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Add Custom Field
      </Button>
    </div>
  );
};

type Props = { type: OrganizationSegmentType };
const Filters = ({ type }: Props) => {
  switch (type) {
    case 'offices':
      return <OfficesFilters />;
    case 'departments':
      return <DepartmentsFilters />;
    case 'designations':
      return <DesignationsFilters />;
    case 'grades':
      return <GradesFilters />;
    case 'custom-fields':
      return <CustomFieldsFilters />;
    default:
      return null;
  }
};
export default Filters;
